import MainMenuBtn from './main-menu-btn';

export default MainMenuBtn;